const layerLineStyle = {
  'id': 'line-animation',
  'type': 'line',
  'source': 'line',
  'layout': {
    'line-cap': 'round',
    'line-join': 'round'
    },
  'paint': {
    'line-width': 5,
    'line-opacity': [
      'case',
      ["boolean", ["feature-state", "selected"], false],
      1,
      ["boolean", ["feature-state", "hover"], false],
      0.8,
      0.5
    ],
    'line-gradient': [
      'interpolate',
      ['linear'],
      ['line-progress'],
      0,
      '#007cbf',
      1,
      '#bf4300'
    ]
  }
};

export default layerLineStyle